import { useEffect, useRef, useState } from 'react';
export const useWindowResize = (callback, debounceTime) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const timeoutId = useRef(null);
    const resizeInner = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
        if (callback)
            callback();
    };
    const resizeDebounce = () => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        timeoutId.current = setTimeout(resizeInner, debounceTime ? debounceTime : 500);
    };
    useEffect(() => {
        window.addEventListener('resize', resizeDebounce);
        return () => {
            window.removeEventListener('resize', resizeDebounce);
        };
    }, []);
    return { windowWidth: width, windowHeight: height };
};
